import React, { useContext, useEffect } from 'react';
import { Box, Text, Colors } from '@tapresearch/ui/components';
import {
  AccordionPanel,
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  useAccordionItemState,
} from '@chakra-ui/react';

import { filterContext } from '../FilterProvider';

export interface FilterAccordionItemProps {
  title: string;
  filterName: string;
}

export function FilterAccordionItem(
  props: React.PropsWithChildren<FilterAccordionItemProps>
) {
  const { title, children, filterName } = props;

  const { filterValues } = useContext(filterContext);
  const filterValue = filterValues[filterName];

  const filtersApplied = Array.isArray(filterValue)
    ? filterValue.length
    : filterValue !== undefined
    ? 1
    : undefined;

  // const { onOpen } = useAccordionItem({ id: filterName });

  return (
    <AccordionItem id={`${filterName}-accordion-item`}>
      {({ isExpanded }) => (
        <FilterAccordionContent
          filterName={filterName}
          title={title}
          isExpanded={isExpanded}
          filtersApplied={filtersApplied}
        >
          {children}
        </FilterAccordionContent>
      )}
    </AccordionItem>
  );
}

interface FilterAccordionContentProps {
  isExpanded: boolean;
  filtersApplied?: number;
  title: string;
  filterName: string;
}

function FilterAccordionContent({
  isExpanded,
  filtersApplied,
  filterName,
  children,
  title,
}: React.PropsWithChildren<FilterAccordionContentProps>) {
  const { onOpen } = useAccordionItemState();

  useEffect(() => {
    if (filtersApplied && !isExpanded) {
      onOpen();
    }
  }, [filtersApplied, onOpen, isExpanded]);

  return (
    <>
      <h2>
        <AccordionButton
          data-testid={`${filterName}-filter-accordion-button${
            isExpanded ? '-opened' : ''
          }`}
          {...{
            paddingTop: '6',
            paddingX: '6',
            paddingBottom: '6',
            fontSize: 'lg',
            fontWeight: 'bold',
            outline: 'none',
            _focus: { outline: 'none' },
            _hover: {
              bgColor: 'none',
            },
          }}
        >
          <Box flex="1" textAlign="left">
            {title}
          </Box>
          {filtersApplied > 0 && (
            <Text mr="3" fontSize="sm" color={Colors.gray[500]}>
              Targets: {filtersApplied}
            </Text>
          )}
          <AccordionIcon />
        </AccordionButton>
      </h2>

      <AccordionPanel
        data-testid={`${filterName}-filter-accordion-panel`}
        px="6"
        paddingTop="0"
        paddingBottom="6"
      >
        {children}
      </AccordionPanel>
    </>
  );
}
